<template>
  <div class="bg-white h-full mx-auto flex justify-center items-center watermark">
    <div>

      <img src="@/assets/logo-pink.svg" class="h-32 mx-auto"/>

      <!-- number -->

      <template v-if="step === steps.PHONE">
        <form @submit.prevent="onSubmitPhone" class="flex flex-col items-center">
          <div class="bg-gray-200 rounded mt-12 p-5 text-center shadow-lg">
            <div class="font-bold text-lg mb-4">Velkommen til Praksispoolen</div>
            Vennligst oppgi ditt mobilnummer for å motta en tekstmelding med kode for pålogging.
          </div>
          <div class="flex items-center justify-center mt-12">
            <label for="phone" class="font-bold">Ditt mobilnummer</label>
            <input class="ml-4 w-12 text-center text-gray-600" type="text" value="+47" tabindex="-1" readonly />
            <input class="ml-2 w-24" type="tel" id="phone" v-model="phone" ref="phone" required>
          </div>
          <div class="text-center p-5 mt-12 bg-red-100 rounded" v-if="error === errors.UNKNOWN_PHONE">
            Mobilnummeret er ikke registrert i våre systemer. Vennligst ta kontakt med praksiskoordinator ved ditt studiested.
          </div>
          <div class="text-center mt-12">
            <button type="submit" class="btn btn-primary">Neste</button>
          </div>
        </form>
      </template>

      <!-- code -->

      <template v-else>
        <div v-if="error === errors.INVALID_CODE" class="text-center">
          <div class="p-5 mt-12 bg-red-100 rounded">
            Ugyldig kode, vennligst forsøk igjen.
          </div>
          <button class="btn btn-primary mt-12" @click="onReset">Tilbake</button>
        </div>
        <form v-else @submit.prevent="onSubmitCode" class="flex flex-col items-center">
          <div class="bg-gray-200 rounded mt-12 p-5 text-center shadow-lg">
            <div class="font-bold text-lg mb-4">Verifisering</div>
            Oppgi kode mottatt på SMS for pålogging.<br/>Kontakt praksiskoordinator dersom du ikke mottar SMS.
          </div>
          <div class="flex items-center justify-center mt-12">
            <label for="code" class="font-bold">SMS kode</label>
            <input class="ml-4 w-20" type="text" id="code" v-model="code" ref="code" required>
          </div>
          <div class="text-center mt-12" else>
            <button type="submit" class="btn btn-primary">Neste</button>
          </div>
        </form>
      </template>

    </div>
  </div>
</template>

<script>

import api from '@/api'

const steps = {
  PHONE : 0,
  CODE: 1
}

const errors = {
  UNKNOWN_PHONE: 0,
  INVALID_CODE: 1
}

export default {
  name: 'st-login',
  data () {
    return {
      steps,
      step: steps.PHONE,
      errors,
      error: null,
      phone: '',
      code: '',
    }
  },
  methods: {

    async onSubmitPhone () {
      const response = await api.st.verify(this.phone)
      if (response.status === 400) {
        this.error = errors.UNKNOWN_PHONE
      } else {
        this.step = this.steps.CODE
        this.$nextTick(() => {
          this.$refs.code.focus()
        })
      }
    },

    async onSubmitCode () {
      this.$store.dispatch('login', {
        username: this.phone,
        password: this.code
      }).then(() => {
        this.$router.push('/st/forside')
      }).catch(() => {
        this.error = errors.INVALID_CODE
      })
    },

    onReset () {
      this.error = null
      this.step = this.steps.PHONE
      this.phone = ''
      this.code = ''
      this.$nextTick(() => {
        this.$refs.phone.focus()
      })
    }

  },

  mounted () {
    this.$refs.phone.focus()
  }
}

</script>
